<template>
  <div class="recharge_left">
    <div class="rechargeheader">
      <el-row class="rechargeHeader">
        <el-col :span="12">
          <h3>{{ $t('rechargeau.myAccount') }}</h3>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <div class="content-flex">
            <div>
              <span v-if="isSimulateBtn == 1">{{ $t('field.Login_freeTrial') }}: 
                <el-switch v-model="isSimulate" activeColor="#ee5c35" @change="toggleChange">
                </el-switch>
              </span>
              <router-link v-if="!isSimulate" to="/myaccount/capital">
                <el-button type="danger" size="small" style="
                    background-color: #00b4b2;
                    border-color: #00b4b2;
                    padding: 9px 25px;
                  ">{{ $t('rechargeau.recharge') }}</el-button>
              </router-link>
              <router-link v-if="!isSimulate" :to="{
                path: '/myaccount/capital',
                query: { active: 'withdraw' },
              }">
                <el-button type="danger" size="small" style="
                    background-color: var(--baseColor);
                    border-color: var(--baseColor);
                    padding: 9px 25px;
                  ">{{ $t('rechargeau.withdraw') }}</el-button>
              </router-link>
              <el-button @click="signIn" type="danger" size="small" style="
                  background-color: #e1b87c;
                  border-color: #e1b87c;
                  padding: 9px 25px;
                ">{{ $t('rechargeau.signin') }}</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- NEW UI CHANGE 16.01.2025 -->
      <div class="userBalance">
        <el-row :gutter="10">
          <el-col :span="24">
            <div class="balanceLeft content-flex">
              <h4>
                {{ $t('rechargeau.CurrentTotalAsset') }} 
              </h4>
              <p class="balance">
                {{ currentTotalAsset.toFixed(2)}}<span style="font-size: 20px">{{ $t('friendCoupon.yuan') }}</span>
              </p>
            </div>
          <!-- <el-col :span="3">
              <div class="balanceLeft content-flex">
                <h4>定期宝&nbsp;<router-link to="/myaccount/finance_fund" style="color: var(--baseColor)">明细</router-link></h4>
                <p><span class="balance">{{finance}}</span>&nbsp;元</p>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="balanceLeft content-flex">
                <h4>节日宝&nbsp;<router-link to="/myaccount/holiday_fund" style="color: var(--baseColor)">明细</router-link></h4>
                <p><span class="balance">{{holiday}}</span>&nbsp;元</p>
              </div>
            </el-col> -->
          <!-- <el-col :span="12">
            <div class="balanceLeft content-flex">
              <h4>
                {{ $t('timeBao.title') }}
                <router-link to="/myaccount/timebao" style="color: var(--baseColor); float: right">{{ $t('rechargeau.details')
                }}</router-link>
              </h4>
              <p class="balance">
                {{ timebao_accout.toFixed(2) }}<span style="font-size: 20px">{{ $t('friendCoupon.yuan') }}</span>
              </p>
            </div>
          </el-col> -->
          <!-- <el-col :span="8" :offset="7"> </el-col> -->
        </el-col>
        </el-row>
      </div>
      <div class="userBalance">
        <el-row :gutter="10">
          <el-col :span="12">
            <div class="balanceLeft content-flex">
              <h4>
                {{ $t('rechargeau.mainAccountBalance') }} 
                <router-link to="/myaccount/detailed" style="color: var(--baseColor); float: right">{{ $t('rechargeau.viewDetails')
                }}</router-link>
              </h4>
              <p class="balance">
                {{ cash.toFixed(2) }}<span style="font-size: 20px">{{ $t('friendCoupon.yuan') }}</span>
              </p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="balanceLeft content-flex">
              <h4>
                {{ $t('rechargeau.capitalAccountBalance') }} 
                <router-link to="/myaccount/strategynow" style="color: var(--baseColor); float: right">{{ $t('rechargeau.viewDetails')
                }}</router-link>
              </h4>
              <p class="balance">
                {{ capitalAsset.toFixed(2)}}<span style="font-size: 20px">{{ $t('friendCoupon.yuan') }}</span>
              </p>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="userBalance">
        <el-row :gutter="10">
          <el-col :span="12">
            <div class="balanceLeft content-flex">
              <h4>
                {{ $t('rechargeau.cashBonus') }}
                <router-link to="/myaccount/red_envelope" style="color: var(--baseColor); float: right">{{ $t('rechargeau.viewDetails')
                }}</router-link>
              </h4>
              <p class="balance">
                {{ redEnvelop.toFixed(2) }}<span style="font-size: 20px">{{ $t('friendCoupon.yuan') }}</span>
              </p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="balanceLeft content-flex">
              <h4>
                {{ $t('rechargeau.voucherBalance') }}
                <router-link :to="{ path: '/myaccount/detailed', query: { tab: 'vouchermanage_log' } }"
                  style="color: var(--baseColor); float: right"
                >
                  {{ $t('rechargeau.viewDetails') }}
                </router-link>
              </h4>
              <p class="balance">
                {{ voucher_management.toFixed(2) }}<span style="font-size: 20px">{{ $t('friendCoupon.yuan') }}</span>
              </p>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="userBalance">
        <el-row :gutter="10">
          <el-col :span="12">
            <div class="balanceLeft content-flex">
              <h4>
                {{ $t('timeBao.title') }} 
                <router-link to="/myaccount/timebao" style="color: var(--baseColor); float: right">{{ $t('rechargeau.viewDetails')
                }}</router-link>
              </h4>
              <p class="balance">
                {{ timebao_accout.toFixed(2) }}<span style="font-size: 20px">{{ $t('friendCoupon.yuan') }}</span>
              </p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="balanceLeft content-flex">
              <h4>
                {{ $t('rechargeau.PromotionAccount') }} 
                <router-link to="/myaccount/agency" style="color: var(--baseColor); float: right">{{ $t('rechargeau.viewDetails')
                }}</router-link>
              </h4>
              <p class="balance">
                {{ agent_account.toFixed(2) }}<span style="font-size: 20px">{{ $t('friendCoupon.yuan') }}</span>
              </p>
            </div>
          </el-col>
        </el-row>
      </div>
      
      <!-- <div class="userContent">
        <el-row :gutter="10">
          <el-col :span="5">
            <div class="contentDetails content-flex">
              <h5>{{ $t('rechargeau.totalAssets') }}</h5>
              <p>{{ total.toFixed(2) }}{{ $t('friendCoupon.yuan') }}</p>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="contentDetails content-flex">
              <h5>{{ $t('rechargeau.availableFunds') }}</h5>
              <p>{{ cash.toFixed(2) }}{{ $t('friendCoupon.yuan') }}</p>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="contentDetails content-flex">
              <h5>{{ $t('rechargeau.totalFreezeMargin') }}</h5>
              <p>{{ bond.toFixed(2) }}{{ $t('friendCoupon.yuan') }}</p>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="contentDetails content-flex">
              <h5>{{ $t('capitalAccount.voucherLabel') }}</h5>
              <p>{{ voucher_management.toFixed(2) }}{{ $t('friendCoupon.yuan') }}</p>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="contentDetails content-flex">
              <h5>{{ $t('rechargeau.agencyCommission') }}</h5>
              <p>{{ agent_account.toFixed(2) }}{{ $t('friendCoupon.yuan') }}</p>
            </div>
          </el-col>
        </el-row> -->
        <!-- <el-divider></el-divider> -->
        <!-- <el-row> -->
        <!--<el-col :span="3">
              <div class="contentDetails content-flex">
                <h5>总配资金额</h5>
                <p>{{total_capital.toFixed(2)}} <span>元</span></p>
              </div>
            </el-col>
            <el-col :span="1">
              <p class="contentDetails content-flex contentAdd"></p>
            </el-col>-->
        <!-- <el-col :span="3">
              <div class="contentDetails content-flex">
                <h5>总证券市值</h5>
                <p>{{market.toFixed(2)}} <span>元</span></p>
              </div>
            </el-col> -->
        <!-- <el-col :span="1">
              <p class="contentDetails content-flex contentAdd"></p>
            </el-col> -->
        <!-- <el-col :span="3">
              <div class="contentDetails content-flex">
                <h5>总浮动盈亏</h5>
                <p>{{profit_loss.toFixed(2)}} <span>元</span></p>
              </div>
            </el-col>
            <el-col :span="1">
              <p class="contentDetails content-flex contentAdd"></p>
            </el-col> -->
        <!-- <el-col :span="3">
              <div class="contentDetails content-flex">
                <h5>总冻结资金</h5>
                <p>{{frozen.toFixed(2)}} <span>元</span></p>
              </div>
            </el-col> -->
        <!-- </el-row> -->
      <!-- </div> -->
      <!-- <div class="userPerfect">
          <el-row>
            <el-col :span="8">
              <div class="perfect_content">
                <div class="perfect_title">
                  <p class="perfect_img">
                    <i class="el-icon-c-scale-to-original"></i>
                  </p>
                  <div>
                    <p>实名认证</p>
                    <p>实名认证</p>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>-->

      <!--<div class="userInfo">
        <el-row>
          <el-col :span="6" >
            <div class="userLeft">
              <div class="userContent user-flex">
                <h2>资产总计</h2>
                <p class="red">{{total}}</p>
              </div>
              <div class="userContent user-flex">
                <div>
                  <router-link to="/myaccount/capital">
                    <el-button type="danger" >充值</el-button>
                  </router-link>
                  <router-link to="/myaccount/capital">
                    <el-button type="primary" >提现</el-button>
                  </router-link>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="4" :offset="1">
            <div class="userRight">
              <div class="userContent user-flex">
                <h3>可用资金<router-link to="/myaccount/detailed"><span class="red detail">[明细]</span></router-link></h3>
                <p class="red">{{cash}}</p>
              </div>
              <div class="userContent user-flex">
                <h3>总配资金额<router-link to="/myaccount/detailed"><span class="red detail">[明细]</span></router-link></h3>
                <p class="red">{{total_capital}}</p>
              </div>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="userRight">
              <div class="userContent user-flex">
                <h3>总冻结保证金</h3>
                <p class="red">{{bond}}</p>
              </div>
              <div class="userContent user-flex">
                <h3>总证券市值<router-link to="/myaccount/detailed"><span class="red detail">[明细]</span></router-link></h3>
                <p class="red">{{market}}</p>
              </div>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="userRight">
              <div class="userContent user-flex">
                <h3>代金券<router-link to="/myaccount/detailed"><span class="red detail">[明细]</span></router-link></h3>
                <p class="red">{{voucher_management}}</p>
              </div>
              <div class="userContent user-flex">
                <h3>总浮动盈亏</h3>
                <p class="red">{{profit_loss}}</p>
              </div>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="userRight">
              <div class="userContent user-flex">
                <h3>代理佣金<router-link to="/myaccount/detailed"><span class="red detail">[明细]</span></router-link></h3>
                <p class="red">{{agent_account}}</p>
              </div>
              <div class="userContent user-flex">
                <h3>总冻结资金</h3>
                <p class="red">{{frozen}}</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>-->
    </div>
    <!-- <div class="rechargeaumoudle">
      <div class="rehcarge2_current">
        &lt;!&ndash; <router-link to="/myaccount/rechange/quickpay">支付宝支付</router-link>
        <router-link to="/myaccount/rechange/wx">数字货币充值</router-link> &ndash;&gt;
        <router-link to="/myaccount/rechange/authentication" class="recharge2_border">支付宝支付</router-link>
        <router-link to="/myaccount/rechange/quickpay">快捷充值</router-link>
        &lt;!&ndash; <router-link to="/myaccount/rechange/netpay">网银支付</router-link> &ndash;&gt;
        &lt;!&ndash; <router-link to="/myaccount/rechange/sweep">网银支付</router-link>
        <router-link to="/myaccount/rechange/netpay2">扫码支付</router-link> &ndash;&gt;
        <router-link to="/myaccount/rechange/rechargelist">充值记录</router-link>
      </div>
      <div class="recharge2_content">
        <div class="recharge2_right">
          <div class="process">
            <table border="1" cellspacing="0" cellpadding="0" class="banK1_table1">
              <tr>
                <td class="text-ident">转账金额</td>
                <td height="80px">
                  <div class="span-tittle">
                    <span>人民币：</span>
                    <el-input
                      class="recharge-money"
                      v-model="inputMoney"
                      type="number"
                      placeholder="请输入充值人民币"
                    ></el-input>
                    <span style="color: #f83200;">*</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="text-ident">
                  <el-radio v-model="type" label="1">支付宝充值</el-radio>
                </td>
                <td height="200px">
                  <img class="img-range" :src="zfbSrc">
                </td>
              </tr>
              &lt;!&ndash; <tr>
                <td class="text-ident">
                  <el-radio v-model="type" label="2">微信充值</el-radio>
                </td>
                <td height="200px">
                  <img class="img-range" :src="wxSrc">
                </td>
              </tr> &ndash;&gt;
              <tr>
                <td class="text-ident">
                  <el-radio v-model="type" label="3">银行充值</el-radio>
                </td>
                <td class="td-p" height="180px">
                  <p>姓名：{{name}}</p>
                  <p>银行名称：{{bank}}</p>
                  <p>银行卡号：{{card}}</p>
                  <p>开户行名称：{{address}}</p>
                </td>
              </tr>
              <tr>
                <td></td>
                <td height="60px">
                  <el-button
                    class="bank1_btn1"
                    type="danger"
                    plain
                    @click="pay"
                    :disabled="disabled"
                  >前往支付</el-button>
                </td>
              </tr>
            </table>
          </div>
          <div class="recharge2_p11 bank1_p1">
            <span class="bank1_span1">温馨提示:</span>
            <p v-html="content"></p>
          </div>
        </div>
      </div>
    </div>-->
    <el-dialog id="couponContentPopup" v-if="couponPopupContent" :visible.sync="couponPopShow">
      <el-form ref="form" label-width="100px">
        <el-form-item>
          <p style="text-align: center; font-size: 17px; display: none">
            {{ $t('rechargeau.firstChargeGiftList') }}
          </p>
          <div v-html="couponContent" style="cursor: pointer; text-align: center"></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="cancelCoupon()" class="dialog-cancel">{{ $t('rechargeau.remindInThisWeek') }} </el-button>
        <el-button type="primary" style="background-color: var(--baseColor);border-color:var(--baseColor)" @click="goToCoupon()">{{ $t('rechargeau.friendCoupons') }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog id="realNameVerifiedPopup" :visible.sync="isRealNameVerified">
      <el-form ref="form" label-width="100px" size="small">
        <el-form-item>
          <!-- <p style="text-align: center; font-size: 17px">{{ $t('account.noRealName') }}</p>
          <p style="text-align: center; font-size: 17px; margin-top: 10px">
            {{ $t('account.pleaseActiveRealName') }}<span>&nbsp;{{ sys_give_voucher_amount }}&nbsp;</span>{{
              $t('account.giftMoney') }}
          </p> -->
          <p v-html="realNameContent"></p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="cancel()">{{ $t('account.cancel') }}</el-button>
        <el-button type="primary" style="background-color: var(--baseColor);border-color:var(--baseColor)" @click="real.realStatus = true">{{ $t('account.realNameNow') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog id="firstTimeRechargePopup" :visible.sync="isFirstTimeRecharge">
      <el-form ref="form" label-width="100px" size="small">
        <el-form-item>
          <p style="text-align: center; font-size: 17px; display: none">
            {{ $t('rechargeau.firstChargeGiftList') }}
          </p>
          <div v-html="before_recharge" style="cursor: pointer" @click="goToRechargeContent()"></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="cancelRecharge()" class="dialog-cancel">{{ $t('account.cancel') }}</el-button>
        <el-button type="primary" style="background-color: var(--baseColor);border-color:var(--baseColor)" @click="goToRecharge()">{{ $t('rechargeau.recharge') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog id="firstTimeTradingPopup" :visible.sync="isFirstTimeTrading">
      <el-form ref="form" label-width="100px" size="small">
        <el-form-item>
          <!-- <p style="text-align: center; font-size: 17px;">
            {{ $t('rechargeau.newMemberTrade') }}
          </p> -->
          <div v-html="before_trading" style="cursor: pointer" @click="goToTradingContent()"></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="cancelTrade()" class="dialog-cancel">{{ $t('account.cancel') }}</el-button>
        <el-button type="primary" style="background-color: var(--baseColor);border-color:var(--baseColor)" @click="goToTrade()">{{ $t('rechargeau.capitalAllocation') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="$t('modifyRealName.verified')" :visible.sync="real.realStatus" width="25%"
      :close-on-click-modal="false">
      <el-form :model="real">
        <el-form-item>
          <el-input :placeholder="$t('rechargeau.enterYourRealName')" v-model="real.inputReal"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input :placeholder="$t('rechargeau.enterYourID')" v-model="real.inputIdcard"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="real.realStatus = false" class="dialog-cancel">{{ $t('rechargeau.cancel') }}</el-button>
        <el-button type="primary" style="background-color: var(--baseColor);border-color:var(--baseColor)" @click="setReal">{{ $t('rechargeau.sure') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import $ from "jquery";
import Rechargeheader from "./../components/rechargeheader";
export default {
  name: "Rechargehome",
  components: {
    Rechargeheader
  },
  data() {
    return {
      isSimulate: false,
      //配资保证金
      bond: 0,
      //账户余额
      cash: 0,
      //提现未批准总额
      frozen: 0,
      //持仓总市值
      market: 0,
      phone: "",
      //总市值+现金
      total: 0,
      time: "",
      //佣金总额
      agent_account: 0,
      //代金卷总额
      voucher_management: 0,
      //浮动盈亏
      profit_loss: 0,
      //定期宝
      finance: 0,
      //余额宝
      holiday: 0,
      timebao_accout: 0,
      isRealNameVerified: false,
      isFirstTimeRecharge: false,
      isFirstTimeTrading: false,
      sys_give_voucher_amount: "",
      before_recharge: "",
      before_trading: "",
      couponContent: "",
      couponPopShow: true,
      isRealNamePopShow: false,
      isRechargePopShow: false,
      isTradingPopShow: false,
      isFriendId: "",
      couponPopupContent: false,
      real: {
        inputReal: '',
        inputIdcard: '',
        realStatus: false
      },
      isSimulateBtn:0,
      realNameContent:'',
      redEnvelop:0,
      capitalAsset:0,
      currentTotalAsset:0,


    };
  },
  created() {
    this.$store.state.accountType = 1;
  },
  computed: {
    //总配资金额
    total_capital: function () {
      let that = this;
      return Number(that.market) + Number(that.profit_loss) + Number(that.frozen)
    }
  },
  mounted: function () {
    this.getConfigsValues();
    this.getRealNamePopupContent();
    this.getUserinfo();
    this.isFriendCoupon();
    this.couponPopup();
    this.getConfig();
    if (localStorage.getItem("couponStatus") == "false") {
      this.couponPopShow = false;
    }
    if (localStorage.getItem("couponStatus") == "true") {
      this.couponPopShow = true;
    }
    this.isSimulate = localStorage.getItem('isSimulation') === 'true';
  },
  methods: {
    getRealNamePopupContent() {
      let that = this;
      that
        .$http({
          url: "/app/Sysconfig/sysconfig/name",
          method: "post",
          data: {
            name: "real_name_popup"
          }
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.realNameContent = res.data.data;
          } else {}
        });
    },
    
    getConfig() {
      let that = this;
      that
        .$http({
          url: "/app/User/user_info",
          method: "post",
          data: {

          }
        })
        .then(function (res) {
          if (res.data.status == 200) {
            if (res.data.data.real != null) {    
              localStorage.setItem('real_verified', true);
            } else {
              localStorage.setItem('real_verified', false);
            }
          }
        });
    },
    toggleChange() {
      this.simulateId = localStorage.getItem('isSimulation');
      this.getSimulationToken();
      // if (this.simulateId) {
      // 	// let token = sessionStorage.getItem("token");
      // 	// let alt_token = sessionStorage.getItem("alt_token");
      //   this.getSimulationToken();
      // } else {

      // }
    },
    getSimulationToken() {
      let that = this;
      that
        .$http({
          url: "/app/UserSimulate/login",
          method: "post",
          data: {},
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then(function (res) {
          if (res.data.status == 200) {
            window.sessionStorage.setItem("token", res.data.data.token);
            localStorage.setItem('isSimulation', true);
            that.getUserinfo();
            setTimeout(() => {
              window.location.reload();
            }, 500);
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    setReal() {
      let that = this;
      if (that.real.inputReal == "") {
        that.$message.error(that.$t('rechargeau.enterYourRealName'));
      } else if (that.real.inputIdcard == "") {
        that.$message.error(that.$t('rechargeau.enterYourId'));
      } else {
        that
          .$http({
            url: "/app/User/certification",
            method: "post",
            data: {
              name: that.real.inputReal,
              card: that.real.inputIdcard,
              is_simulate: localStorage.getItem('isSimulation') === 'true' ? 1 : 0
            }
          })
          .then(function (res) {
            if (res.data.status == 200) {
              that.$message({
                message: that.$t(res.data.msgId),
                type: "success",
                duration: 1000,
                onClose: function () {
                  that.real.realStatus = false;
                  that.recharge.realStatus = true;
                }
              });
              that.isRealNameVerified = false;
              that.getUserinfo();
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(that.$t(res.data.msgId));
            }
          });
      }
    },
    goToRechargeContent() {
      // this.$router.push({path:'/popcontent?activityid=recharge_popup_image'})
      this.$router.push({
        path: "/popcontent1?activityid=recharge_popup_image_pc"
      })
      //  this.$router.push({
      //   path:"/stockdetailed?symbol=sh000001"
      // })
    },
    goToTradingContent() {
      // this.$router.push({path:'/popcontent?activityid=recharge_popup_image'})
      // this.$router.push({
      //   path: "/popcontent1?activityid=trading_popup_image_pc"
      // })
      //  this.$router.push({
      //   path:"/stockdetailed?symbol=sh000001"
      // })
    },
    getUserinfo() {
      let that = this;
      that
        .$http({
          url: "/app/User/user",
          method: "post",
          data: {},
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then(function (res) {
          if (res.data.status == 200) {
            let resData = res.data.data;
            that.bond = Number(resData.bond);
            that.cash = Number(resData.cash);
            that.frozen = Number(resData.frozen);
            that.market = Number(resData.market);
            that.phone = Number(resData.phone);
            that.total = Number(resData.cash) + Number(resData.bond) + Number(resData.voucher_management) + Number(resData.agent_account);
            that.time = resData.time;
            that.agent_account = Number(resData.agent_account);
            that.voucher_management = Number(resData.voucher_management);
            that.profit_loss = Number(resData.profit_loss);
            that.finance = resData.finance;
            that.holiday = resData.holiday;
            that.timebao_accout = resData.timebao_accout;
            that.redEnvelop = Number(resData.red_envelop);
            that.capitalAsset = Number(resData.total_capital_asset);
            that.currentTotalAsset = Number(resData.total_user_asset);
            that.isSimulate = resData.is_simulate == 0 ? false : true;
            if (resData.real == '' && resData.is_simulate != 1) {
              //show popup
              that.realNameConfig();
              if (that.isRealNamePopShow) {
                that.isRealNameVerified = true;
              }

              // that.$confirm('请完成实名后激活3999元礼金', '实名提醒', {
              //   confirmButtonText: '确定',
              //   cancelButtonText: '取消',
              //   type: 'warning'
              // }).then(() => {
              //   that.$router.push({path:'/myaccount/information'})
              // })
            }
            if (res.data.data.is_simulate == 1)
              localStorage.setItem('isSimulation', true);
            else
              localStorage.setItem('isSimulation', false);

            if (resData.real) {
              // that.isFirstTimeRecharge = true;
              //need to check is first time recharge
              that.isFirstRecharge();
            }

          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },

    getConfigsValues() {
      let that = this;
      that
        .$http({
          url: "/app/Home/configs",
          method: "post",
          data: {
            
          }
        })
        .then(function (res) {
          if (res.data.status == 200) {
            
            if (res.data.data.is_before_recharge == "1") {
              if (!that.isSimulate) {
                that.isRechargePopShow = true;
              }
            } else {
              that.isRechargePopShow = false;

            }

            if (res.data.data.is_before_trading == "1") {
              if (!that.isSimulate) {
                that.isTradingPopShow = true;
              }
            } 
            else {
              that.isTradingPopShow = false;
            
            }

            if (res.data.data.is_real_name_popup == "1") {
              if (!that.isSimulate) {
                that.isRealNamePopShow = true;
              }
            } else {
              that.isRealNamePopShow = false;
            }

            if (res.data.status == 200) {
              that.isSimulateBtn = parseInt(res.data.data.simulate_user_enable);
            } else {
              
            }
          } else {
            
          }
        });
    },


    isFriendCoupon() {
      let that = this;
      that
        .$http({
          url: "/app/FriendCoupon/is_friend_coupon",
          method: "post",
          data: {}
        })
        .then(function (res) {
          if (res.data.status === 200) {
            that.isFriendId = res.data.data;

            var id = localStorage.getItem("friendCouponID");

            if (Number(id) !== Number(that.isFriendId.id)) {
              sessionStorage.removeItem("couponCheck");
            }

            if (!(sessionStorage.getItem("couponCheck"))) {
              if (that.isFriendId.id) {
                if (id === null || Number(id) !== Number(that.isFriendId.id)) {
                  that.couponPopShow = true;
                  localStorage.setItem("friendCouponID", that.isFriendId.id);
                  localStorage.setItem("couponStatus", "true");
                  that.couponPopup();
                } else if (Number(id) === Number(that.isFriendId.id) && localStorage.getItem("couponStatus") === "true") {
                  that.couponPopShow = true;
                  that.couponPopup();
                } else if (Number(id) === Number(that.isFriendId.id) && localStorage.getItem("couponStatus") === "false") {
                  that.couponPopShow = false;
                }
              }
            }

            sessionStorage.setItem("couponCheck", "1");
            // if(localStorage.getItem("friendCouponID") !== that.isFriendId.id){
            //   localStorage.setItem("couponStatus", "true");
            // } else {
            //   localStorage.setItem("couponStatus", false);
            // }
            //   var status = localStorage.getItem("couponStatus");
            // if(status === true) {
            //   that.couponPopShow = true;
            //   localStorage.setItem("friendCouponID", that.isFriendId.id);
            //   that.couponPopup();
            // } else {
            //   that.couponPopShow = false;
            // }
          }
        });
    },

    couponPopup() {
      let that = this;
      that
        .$http({
          url: "/app/FriendCoupon/coupon_web_popup",
          method: "post",
          data: {}
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.couponContent = res.data.data[0].popup;
            if (!that.couponContent) {
              that.couponPopShow = false;
              that.couponPopupContent = false;
            } else {
              that.couponPopupContent = true;
            }
            that.couponContent = that.couponContent.replace("http://wonder.apps/friend_coupon", "#/myaccount/friend_coupon");
            that.couponContent = that.couponContent.replace("http://wonder.apps/activity/", "#/stockguild?activityid=");
            // that.couponContent = that.couponContent.replace("http://wonder.apps/activity/11", "#/stockguild?activityid=11");
            // that.couponContent = that.couponContent.replace("http://wonder.apps/activity/17", "#/stockguild?activityid=17");
            // that.couponContent = that.couponContent.replace("http://wonder.apps/activity/15", "#/stockguild?activityid=15");
            // localStorage.setItem("couponStatus", true);
          } else {
            // that.isFirstTimeTrading = true;
            // localStorage.setItem("isFirstTimeRecharge", true);
          }
        });
    },

    realNameConfig() {
      let that = this;
      that
        .$http({
          url: "/app/Sysconfig/sysconfig/name",
          method: "post",
          data: {
            name: "sys_give_voucher_amount"
          }
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.sys_give_voucher_amount = res.data.data;
          } else {
            // that.isFirstTimeTrading = true;
            // localStorage.setItem("isFirstTimeRecharge", true);
          }
        });
    },
    isRealNamePopShowM() {
      let that = this;
      that
        .$http({
          url: "/app/Sysconfig/sysconfig/name",
          method: "post",
          data: {
            name: "is_real_name_popup"
          }
        })
        .then(function (res) {
          if (res.data.data == 1) {
            if (!that.isSimulate) {
              that.isRealNamePopShow = true;
            }
          } else {
            that.isRealNamePopShow = false;

            // that.isFirstTimeTrading = true;
            // localStorage.setItem("isFirstTimeRecharge", true);
          }
        });
    },
    
    
    rechargeConfig() {
      let that = this;
      that
        .$http({
          url: "/app/Sysconfig/sysconfig/name",
          method: "post",
          data: {
            name: "before_recharge"
          }
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.before_recharge = res.data.data;
          } else {

          }
        });
    },
    tradeConfig() {
      let that = this;
      that
        .$http({
          url: "/app/Sysconfig/sysconfig/name",
          method: "post",
          data: {
            name: "before_trading"
          }
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.before_trading = res.data.data;
          } else {

          }
        });
    },
    isFirstTrade() {
      let that = this;
      that
        .$http({
          url: "/app/Deal/isfirst_deal",
          method: "post",
          data: {
            data: 1
          }
        })
        .then(function (res) {
          if (res.data.data.data == 1) {
            that.isFirstTimeTrading = false;
            localStorage.setItem("isFirstTimeRecharge", false);
          } else {
            if (that.isTradingPopShow) {
              that.tradeConfig();
              that.isFirstTimeTrading = true;
              localStorage.setItem("isFirstTimeRecharge", true);
            }
          }
          that.checkIfTradesSold();
        });
    },

    isFirstRecharge() {
      let that = this;
      that
        .$http({
          url: "/app/Recharge/isfirst_recharge",
          method: "post",
          data: {}
        })
        .then(function (res) {
          if (res.data.data.data == 1) {
            that.isFirstTimeRecharge = false;
            that.isFirstTrade();
            localStorage.setItem("isFirstTimeRecharge", false);
            
          } else {
            if (that.isRechargePopShow) {
              that.isFirstTimeTrading = false;
              that.isFirstTimeRecharge = true;
              that.rechargeConfig();

            }
            else if (that.isTradingPopShow) {
              that.isFirstTimeRecharge = false;
              that.isFirstTimeTrading = true;
              that.tradeConfig();

            }
            // localStorage.setItem("isFirstTimeRecharge", true);
          }
        });
    },

    checkIfTradesSold() {
      let that = this;
      that
        .$http({
          url: "/app/Depot/allStocksSold",
          method: "post",
          data: {
            
          }
        })
        .then(function (res) {

          if (res.data.data == 1) {
              that.tradeConfig();
              that.isTradingPopShow = true;
              that.isFirstTimeTrading = true;
          } else {
            
          }
        });
    },

    cancel() {
      this.isRealNameVerified = false;
    },
    cancelRecharge() {
      this.isFirstTimeRecharge = false;
    },
    cancelCoupon() {
      localStorage.setItem("couponStatus", "false");
      // var status = localStorage.getItem("couponStatus");
      // this.$store.commit('couponPopUpCheck',status);
      this.couponPopShow = false;
    },
    cancelTrade() {
      this.isFirstTimeTrading = false;
    },
    goToRealName() {
      // this.$router.push({path:'/myaccount/information'})

    },
    goToRecharge() {
      this.$router.push({ path: '/myaccount/capital' })
    },
    goToCoupon() {
      this.$router.push({ path: '/myaccount/friend_coupon' })
    },
    goToTrade() {
      this.$router.push({
        path: "/operate/operateday"
      })
    },
    //签到
    signIn() {
      let that = this;
      that
        .$http({
          url: "/app/FirstVoucher/checkin",
          method: "post",
          data: {
          }
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.$message({
              message: that.$t(res.data.msg),
              type: 'success',
              onClose: function () {
                that.getUserinfo()
              }
            });
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    }
  }
};
</script>
<style scoped>
* {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.userBalance {
  /* height: 60px; */
  margin: 10px 0px;
}

.userInfo {
  line-height: 30px;
  margin: 70px 0;
}

.detail {
  font-size: 14px;
  font-weight: normal;
}

.userLeft {
  height: 160px;
  border-right: 1px solid #dcdfe6;
}

.userRight {
  height: 160px;
}

.userContent {
  text-align: center;
  background: #ffffff;
  border-radius: 8px;
  padding: 15px 0px;
}

.user-flex {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.content-flex {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.balanceLeft {
  font-size: 14px;
  background: #ffffff;
  padding: 20px;
  border-radius: 8px;
}

.balanceLeft h4 {
  font-weight: normal;
}

.balanceLeft p {
  color: #999;
}

.balanceLeft .balance {
  font-size: 30px;
  color: #f46f83;
  margin-top: 10px;
}

.contentDetails {
  line-height: 1.5;
  height: 60px;
}

.contentDetails h5 {
  color: #58616b;
  font-size: 14px;
  font-weight: 300;
}

.contentDetails p {
  color: #040f1b;
  font-size: 16px;
  /* font-weight: bold; */
}

.contentDetails span {
  color: #999;
}

.contentAdd {
  color: #999;
  font-size: 20px;
  font-weight: bold;
}

.perfect_content {}

.perfect_img {
  width: 60px;
  height: 60px;
  background: #999;
  color: #ffffff;
  font-size: 60px;
  line-height: 60px;
}

.rechargeHeader {
  background: #ffffff;
  padding: 18px 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
}

.dialog-cancel:hover {
  color: var(--baseColor) !important;
  border-color: var(--baseColor) !important;
  background-color: #fff !important;
}
</style>
<style>
#couponContentPopup .el-form-item {
  margin-bottom: 11px;
}

#couponContentPopup .el-dialog__body {
  padding: 0px;
}

#couponContentPopup .el-form-item__content {
  margin-left: 0px !important;
}

#couponContentPopup .el-dialog {
  width: 45%;
  margin-top: 17% !important;
}

#realNameVerifiedPopup .el-form-item {
  margin-bottom: 11px;
}

#realNameVerifiedPopup .el-dialog__body {
  padding: 0px;
}

#realNameVerifiedPopup .el-form-item__content {
  margin-left: 0px !important;
}

#realNameVerifiedPopup .el-dialog {
  width: 25%;
  margin-top: 17% !important;
}

#firstTimeRechargePopup .el-form-item {
  margin-bottom: 11px;
}

#firstTimeRechargePopup .el-dialog__body {
  padding: 0px;
}

#firstTimeRechargePopup .el-form-item__content {
  margin-left: 0px !important;
}

#firstTimeRechargePopup .el-dialog {
  width: 25%;
  margin-top: 17% !important;
}

#firstTimeTradingPopup .el-form-item {
  margin-bottom: 11px;
  /*height: 140px;*/
}

#firstTimeTradingPopup .el-form {
  /* height: 155px;*/
}

#firstTimeTradingPopup .el-dialog__body {
  padding: 0px;
}

#firstTimeTradingPopup .el-form-item__content {
  margin-left: 0px !important;
}

#firstTimeTradingPopup .el-dialog {
  width: 25%;
  margin-top: 17% !important;
}
</style>




// WEBPACK FOOTER //
// src/components/rechargeau.vue